import React from "react";
import "./CSS/register.css";
import CheckoutForm from "./Components/Checkout";

export default function Payment({ location, history }) {
  return (
      <CheckoutForm location={location} history={history} />
  );
}
